module.exports = __webpack_public_path__ + "img/wps.78d52f5a.png";